import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

/*************  ✨ Codeium Command ⭐  *************/
/**
 * A TextField component for Redux Form that is minimalist.
 * @param {Object} input - The props passed to the TextField component.
 * @param {string} label - The label for the TextField component.
 * @param {string} name - The name of the TextField component.
 * @param {string} type - The type of the TextField component (e.g. text, number, etc.).
 * @param {boolean} withFocus - Whether the TextField component should have focus.
 * @param {Object} meta - The metadata for the field, including the touched and error props.
 */
/******  3f0bb3cb-a3fb-48ad-91f8-3c0d6d7b3fac  *******/
const RenderTextFieldReduxMinRead = ({  input, label, name, type, withFocus, meta: { touched, error }}) => {
    return (
        <div>
        <TextField
            {...input}
            type={!type ? "text" : type}
            fullWidth
            disabled
            InputLabelProps= {
              {
                style: { color: '#000000'}
              }
            }
            label={label}
            autoComplete ='off'
        />
        {touched && error && <span style = {{ color: 'red'}}>{error}</span>}
        </div>
    );
};

RenderTextFieldReduxMinRead.propTypes = {
    label: PropTypes.string.isRequired,
};

export default RenderTextFieldReduxMinRead;